module.exports = __webpack_public_path__ + "img/3.b5597ea6.jpeg";